import palette from '@lib/core/src/theme/palette';
import { Stack } from '@mui/material';

interface ProgbarProps {
  currentStep: number;
  totalSteps: number;
}

const Progbar = ({ currentStep = 1, totalSteps = 4 }: ProgbarProps) => {
  return (
    <Stack
      sx={{
        width: '100%',
        height: '10px',
        backgroundColor: palette.grey[200],
        borderRadius: '10px'
      }}
    >
      <div
        style={{
          width: `${(currentStep / totalSteps) * 100}%`,
          height: '10px',
          background: `linear-gradient(90deg, ${palette.blue[500]} 0.02%, ${palette.purple[500]} 36.06%, ${palette.purple[500]} 69.7%, ${palette.grey[200]} 97.58%)`,
          borderRadius: '10px'
        }}
      ></div>
    </Stack>
  );
};

export default Progbar;
